angular.module('calendarApp').directive('descriptionModal', function () {
  return {
    restrict: 'AE',
    scope: {
      service: '=?',
      resource: '=?'
    },
    replace: true,
    templateUrl: smooth.calendar_url + '/partials/directives/description-modal.html',
    link: function link(scope, elem, attrs) {
      scope.modalID = uuidv4();

      scope.showModal = function () {
        $("#".concat(scope.modalID)).modal();
      };

      function uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0,
              v = c == 'x' ? r : r & 0x3 | 0x8;
          return v.toString(16);
        });
      }
    }
  };
}); // End directive